export default __webpack_public_path__ + "static/media/3 - Электронное инфо-табло.6940f39c.jpg";